/**
 * Tencent is pleased to support the open source community by making SPA UI available.
 * Copyright (C) 2021, a Tencent company. All rights reserved
 */
export default (args?: string): void => {
  const i = document.createElement('script');
  if (args) {
    document.documentElement.dataset[args] = args;
  }
  i.src = 'https://ui.tad.woa.com/tools/feedback.js';
  document.body.appendChild(i);
  i.remove();
};
